module.exports = __webpack_public_path__ + "img/zbt.a2dbbcb7.png";